import LegalPage from '../shared/LegalPage';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';

function TermsConditions() {
  const { t } = useLanguage();
  const values = {
    appName: business.appName,
    companyName: business.companyName
  };

  return (
    <LegalPage
      title={t.terms.title}
      intro={fillTemplate(t.terms.intro, values)}
    >
      {t.terms.sections.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          <p>{fillTemplate(section.body, values)}</p>
        </section>
      ))}

      <section>
        <h2>{t.terms.contactTitle}</h2>
        <p>
          {t.terms.contactText}{' '}
          <a href={`mailto:${business.supportEmail}`}>{business.supportEmail}</a>.
        </p>
      </section>
    </LegalPage>
  );
}

export default TermsConditions;
